import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom' // Add this import
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
  Slide,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded'
import TermsAndConditions from './TermsAndConditions'
import Disclaimer from './Disclaimer'
import { useAuth } from '../context/AuthContext'
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.dark,
  },
  textTransform: 'none',
}))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

// Helper function to get cookie
const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null // Return null if cookie doesn't exist
}

// Helper function to set cookie for authenticated users (expires when browser session ends, The cookie is set without an expiration date, which means it will be removed when the browser session ends (browser is closed))
const setSessionCookie = (name, value) => {
  document.cookie = `${name}=${value};path=/`;
};

/**
* Warning popup will:
* - Show only when user is authenticated and not during loading
* - Show on the first visit in each browser session for authenticated users
* - Not show when opening links in new tabs (target="_blank")
* - Reset when the browser is closed, so users will see it again in their next session
* - Not show again during the same session after the terms have been accepted
* - Not show if the user navigates directly to the terms-and-conditions page, since we have give a link in Disclaimer component, which will open every time
 */

const WarningPopup = () => {
  const [open, setOpen] = useState(false)
  const [scroll, setScroll] = useState('paper')
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const descriptionElementRef = useRef(null)
  const [fullWidth, setFullWidth] = useState(true)
  const [maxWidth, setMaxWidth] = useState('md')
  const location = useLocation()
  const { isAuthenticated, isLoading, user } = useAuth()
  useEffect(() => {
    // Don't show popup if still loading auth state OR user is not authenticated
    if (!isAuthenticated || isLoading) {
      return
    }
    // Function to check if the current page was opened from the same origin
    const isFromSameOrigin = () => {
      try {
        return (
          document.referrer &&
          new URL(document.referrer).origin === window.location.origin
        )
      } catch (e) {
        return false
      }
    }

    // Check if we should show the popup
    const shouldShowPopup = () => {
      const hasSeenWarningValue = getCookie('hasSeenWarning')
      const userHasAcceptedTerms = hasSeenWarningValue === 'true'
      const isNewTab = window.opener !== null || isFromSameOrigin()
      const isTermsPage = location.pathname === '/terms-and-conditions'

      // Don't show popup if:
      // 1. User has already accepted terms (cookie value is 'true')
      // 2. Opened from same site (new tab/window from same origin)
      // 3. Currently on terms-and-conditions page
      // 4. User is not authenticated (handled above)
      return !userHasAcceptedTerms && !isNewTab && !isTermsPage
    }
    // Show popup with delay if conditions are met
    if (shouldShowPopup()) {
      const timer = setTimeout(() => {
        setOpen(true)
      }, 7000) // 7 second delay

      // Cleanup timer if component unmounts
      return () => {
        clearTimeout(timer)
      }
    }
  }, [location.pathname, isAuthenticated, isLoading]) // Re-run when route changes to check isTermsPage condition

  // Ensure the dialog does not close unless the "I, Agree" button is clicked
  const handleClose = (event, reason) => {
    // another reason for dialogBox to get close Parent Component Update: If the parent component's state changes in a way that affects the dialog's open prop value.
    if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return // Prevent closing when clicking the backdrop or pressing the escape key
    }
    setOpen(false)
    setSnackbarOpen(true)
    // Set session cookie to remember the warning was shown
    setSessionCookie('hasSeenWarning', 'true')
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return
    setSnackbarOpen(false)
  }

  // Don't render anything if user is not authenticated
  if (!isAuthenticated) {
    return null
  }

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        onClose={handleClose} // Custom onClose logic
        scroll={scroll}
        aria-labelledby='scroll-dialog-title'
        aria-describedby='scroll-dialog-description'
      >
        {/* <DialogTitle id='scroll-dialog-title'>Terms and Conditions</DialogTitle> */}
        <DialogContent dividers={scroll === 'paper'}>
          {/* Render TermsAndConditions component instead of raw HTML */}
          <div
            id='scroll-dialog-description'
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <Disclaimer />
            {/* <TermsAndConditions /> */}
            {/* Display the full terms and conditions component */}
          </div>
        </DialogContent>
        <DialogActions>
          <StyledButton
            variant='contained'
            autoFocus
            onClick={handleClose}
            startIcon={<ThumbUpAltRoundedIcon />}
            sx={{
              color: '#fff',
              bgcolor: '#232536',
              mr: 2,
              fontWeight: 500,
              ':hover': {
                color: '#232536',
                bgcolor: '#ffcf51',
              },
            }}
          >
            I, Agree
          </StyledButton>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity='success'
          sx={{ width: '100%' }}
        >
          Terms accepted. You can now access the website.
        </Alert>
      </Snackbar>
    </>
  )
}

export default WarningPopup